import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  confirm(event) {
    event.preventDefault()

    const reason = prompt("差し戻し理由を入力してください：")

    if (reason === null) {
      // ユーザーがキャンセルした場合
      return
    }

    if (reason.trim() === "") {
      alert("差し戻し理由を入力してください。")
      return
    }

    // hidden inputを追加
    const form = event.target
    const hiddenInput = document.createElement("input")
    hiddenInput.type = "hidden"
    hiddenInput.name = "rejection_reason"
    hiddenInput.value = reason
    form.appendChild(hiddenInput)

    // フォームを送信
    form.submit()
  }
}
